<template>
    <section>
        <b-btn type="primary" @click="open=true">{{$t('message.add_building')}}</b-btn>
        <b-modal v-model="open" :title="$t('message.add_building')" ref="modal" id="modal-building">
            <vue-form-generator ref="createBuilding" :schema="schema" :model="model" :options="formOptions" @validated="onValidated"></vue-form-generator>
            <template #footer>
                <b-btn @click="open=false">{{$t('message.cancel')}}</b-btn>
                <b-btn @click="validate" type="primary">{{$t('message.create')}}</b-btn>
            </template>
        </b-modal>
    </section>
</template>

<script>
    import VueFormGenerator from 'vue-form-generator'
    import storage, {BUILDING_REQUEST} from '../../../_store'
    import mixins from '../../../modules/mixins'
    import eventBus from '../../../modules/eventBus'

    export default {
        name: 'create-building',
        mixins: [mixins],
        props: {
            unit: {
                type: String
            }
        },
        data () {
            return {
                open: false,
                isValid: false,
                model: {
                    name: null,
                    street: '',
                    houseNumber: '',
                    city: '',
                    zip: '',
                    country: '',
                    pricePerLiterCold: 'true-0.1',
                    pricePerLiterHot: 'true-0.1',
                    pricePerPower: 'true-4.5',
                    pricePerUnit: 'true-1'
                },
                schema: {
                    fields: [{
                        type: 'input',
                        inputType: 'text',
                        label: this.$t('message.name'),
                        i18n: {
                            label: 'message.name'
                        },
                        model: 'name',
                        featured: true,
                        required: true,
                        validator: VueFormGenerator.validators.string
                    }, {
                        type: 'input',
                        inputType: 'text',
                        label: this.$t('message.street'),
                        i18n: {
                            label: 'message.street'
                        },
                        model: 'street',
                        required: false
                    }, {
                        type: 'input',
                        inputType: 'text',
                        label: this.$t('message.house_number'),
                        i18n: {
                            label: 'message.house_number'
                        },
                        model: 'houseNumber',
                        required: false
                    }, {
                        type: 'input',
                        inputType: 'text',
                        label: this.$t('message.city'),
                        i18n: {
                            label: 'message.city'
                        },
                        model: 'city',
                        required: false
                    }, {
                        type: 'input',
                        inputType: 'text',
                        label: this.$t('message.zip'),
                        i18n: {
                            label: 'message.zip'
                        },
                        model: 'zip',
                        required: false
                    }, {
                        type: 'input',
                        inputType: 'text',
                        label: this.$t('message.country'),
                        i18n: {
                            label: 'message.country'
                        },
                        model: 'country',
                        required: false
                    }, {
                        type: 'checkboxText',
                        i18n: {
                            label: 'message.price_estimate_cold_water',
                            checkboxLabel: 'message.from_parent_object',
                            unitText: () => this.activeOrganization.currency + ' / ' + this.$t('message.liter')
                        },
                        model: 'pricePerLiterCold',
                        pattern: /^(false|true)-[0-9]+([,.][0-9]+)?$/,
                        validator: [VueFormGenerator.validators.regexp]
                    }, {
                        type: 'checkboxText',
                        i18n: {
                            label: 'message.price_estimate_hot_water',
                            checkboxLabel: 'message.from_parent_object',
                            unitText: () => this.activeOrganization.currency + ' / ' + this.$t('message.liter')
                        },
                        model: 'pricePerLiterHot',
                        pattern: /^(false|true)-[0-9]+([,.][0-9]+)?$/,
                        validator: [VueFormGenerator.validators.regexp]
                    }, {
                        type: 'checkboxText',
                        i18n: {
                            label: 'message.price_estimate_power',
                            checkboxLabel: 'message.from_parent_object',
                            unitText: () => this.activeOrganization.currency + ' / ' + this.$t('message.power')
                        },
                        model: 'pricePerPower',
                        pattern: /^(false|true)-[0-9]+([,.][0-9]+)?$/,
                        validator: [VueFormGenerator.validators.regexp]
                    }, {
                        type: 'checkboxText',
                        i18n: {
                            label: 'message.price_estimate_heat',
                            checkboxLabel: 'message.from_parent_object',
                            unitText: () => this.activeOrganization.currency + ' / ' + this.$t('message.heat_units')
                        },
                        model: 'pricePerUnit',
                        pattern: /^(false|true)-[0-9]+([,.][0-9]+)?$/,
                        validator: [VueFormGenerator.validators.regexp]
                    }]
                },
                formOptions: {
                    validateAfterLoad: false,
                    validateAfterChanged: true
                }
            }
        },
        watch: {
            open (value) {
                if (value) {
                    this.resetModel()
                }
            }
        },
        methods: {
            resetModel () {
              this.model = {
                  name: null,
                  street: '',
                  houseNumber: '',
                  city: '',
                  zip: '',
                  country: '',
                  pricePerLiterCold: 'true-0.1',
                  pricePerLiterHot: 'true-0.1',
                  pricePerPower: 'true-4.5',
                  pricePerUnit: 'true-1'
              }
            },
            onValidated  (isValid) {
                this.isValid = isValid
            },
            validate () {
                this.$refs.createBuilding.validate()
                if (this.isValid) {
                    storage.dispatch(BUILDING_REQUEST, this.model)
                        .then(response => {
                            this.open = false
                            eventBus.emit('change', {force: true, source: 'create-building'})
                        }) // TODO catch ERROR
                }
            }
        }
    }
</script>

<style scoped>

</style>
